idd_addEvent(window, 'load', afvalWindowLoad);

function afvalWindowLoad() {
	var searchField  = document.getElementById('search_field');
	var defaultValue = searchField.value;
	
	idd_addEvent(searchField, 'focus', function () {
		if ( searchField.value == defaultValue ) {
			searchField.value = '';
		}
	});
	
	idd_addEvent(searchField, 'blur', function () {
		if ( searchField.value == '' ) {
			searchField.value = defaultValue;
		}
	});
}
// -----IDD-MINIFY-SETTINGS
// ecmaVersion:11
// -----IDD-MINIFY-SETTINGS-DONE
